<template>
  <form autocomplete="off" class="form-base">
    <slot></slot>
  </form>
</template>

<script>
export default {
  name: 'FormBase',
};
</script>

<style lang="scss">
.form-base {
  position: relative;
  width: 100%;
  max-width: 420px;
  display: flex;
  flex-direction: column;
  font-size: 16px;

  label {
    display: none;
    align-self: flex-start;
    margin-bottom: 8px;
    font-weight: bold;

    &.show-label {
      display: inline-block;
      font-weight: normal;
      margin: 0 auto 15px;
    }

    &.checkbox {
      text-align: left;
      font-weight: normal;
    }
  }

  select,
  input,
  textarea {
    width: 100%;
    padding: 12px 15px;
    border: 2px solid #979797;
    border-radius: 3em;
    font-family: 'Nunito', Helvetica, Roboto, Arial, sans-serif;
    transition: all 0.2s ease-in;
    margin-bottom: 24px;
    font-weight: bold;
    line-height: 22px;

    &:focus {
      border: 2px solid #333333;
      color: black;
      transition: all 0.2s ease-in;
      &::-ms-value {
        background-color: black;
      }
    }

    &.has-content {
      border: 2px solid black !important;
    }
    &.has-errors {
      border: 2px solid red !important;
    }
  }
  select {
    padding: 10px 15px;
    min-height: 44px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none; /* Remove default arrow */
    background-image: url('../images/dd-arrow.svg'); /* Add custom arrow */
    background-repeat: no-repeat;
    background-position: 97%;

    @media all and (-ms-high-contrast: none) {
      background-image: none;
    }
  }
  option {
    background-color: black;
    color: white;

    &.disabled {
      color: gray;
    }
  }
  .form-row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .form-column {
    display: flex;
    flex-direction: column;
    flex: 1;

    &.column-double {
      flex: 2;
      @media print, screen and (max-width: 580px) {
        width: 100%;
        flex: none;
      }
    }
    &.column-triple {
      flex: 3;
    }
  }
  .form-row {
    .form-column:not(:last-child) {
      margin-right: 10px;
    }
  }
}
</style>
